module.exports = __webpack_public_path__ + "img/product-postcard-business.e2d84c31.svg";